export default {
  "lang.label": "Language",
  "lang.zh-TW": "Traditional Chinese",
  "lang.zh-CN": "Simplified Chinese",
  "lang.en": "English",
  "lang.ja": "Japanese",
  "nav.home": "Home",
  "nav.about": "About the Brand",
  "nav.books": "Book Catalog",
  "nav.stores": "Retail Channels",
  "nav.faq": "FAQ",
  "nav.blog": "Editor's Picks",
  "nav.contact": "Contact",
  "nav.partners": "Partners",
  "nav.services": "Services",
  "nav.app": "Shuangdu App",
  "nav.more": "More",
};
